export default __webpack_public_path__ + "static/media/TR-en.5c51d1d0.svg";